import React from 'react';
import { MemberPersonSection } from './MemberListSectionParts';

export default function MemberPeopleSections({
  admins = [],
  onAdminClick,
  adminKeyResolver,
  formatAdminName,
  resolveAdminMembershipLabel,
  adminAvatarStyle,
  adminInitial,
  plannerMembers = [],
  showPlanner = false,
  onPlannerClick,
  avatarStyle,
  avatarInitial,
  sectionClassName,
  responsibleSectionClassName,
  plannerSectionClassName,
  titleClassName,
  listClassName,
  rowClassName,
  avatarClassName,
  textClassName,
  nameClassName,
  metaClassName,
  membershipClassName,
  emptyClassName,
  responsibleTitle = '担当者',
  responsibleEmptyText = '未設定',
  plannerTitle = '企画者',
  plannerEmptyText = '企画者が設定されていません',
}) {
  return (
    <>
      <MemberPersonSection
        title={responsibleTitle}
        people={admins}
        onClick={onAdminClick}
        getKey={adminKeyResolver}
        getName={formatAdminName}
        getMeta={(admin) => [admin?.position, admin?.department].filter(Boolean).join(' / ')}
        getMembership={resolveAdminMembershipLabel}
        getAvatarImage={(admin) =>
          admin?.profile_picture || admin?.admin_profile_picture || admin?.picture || admin?.pic || ''
        }
        avatarStyle={adminAvatarStyle}
        avatarInitial={adminInitial}
        sectionClassName={responsibleSectionClassName || sectionClassName}
        titleClassName={titleClassName}
        listClassName={listClassName}
        rowClassName={rowClassName}
        avatarClassName={avatarClassName}
        textClassName={textClassName}
        nameClassName={nameClassName}
        metaClassName={metaClassName}
        membershipClassName={membershipClassName}
        emptyClassName={emptyClassName}
        emptyText={responsibleEmptyText}
      />
      {showPlanner ? (
        <MemberPersonSection
          title={plannerTitle}
          people={plannerMembers}
          onClick={onPlannerClick}
          getKey={(planner) => planner?.key}
          getName={(planner) => planner?.name}
          getMembership={(planner) => planner?.eventMembershipLabel || ''}
          getAvatarImage={(planner) => planner?.pic || ''}
          avatarStyle={avatarStyle}
          avatarInitial={avatarInitial}
          sectionClassName={plannerSectionClassName || sectionClassName}
          titleClassName={titleClassName}
          listClassName={listClassName}
          rowClassName={rowClassName}
          avatarClassName={avatarClassName}
          textClassName={textClassName}
          nameClassName={nameClassName}
          metaClassName={metaClassName}
          membershipClassName={membershipClassName}
          emptyClassName={emptyClassName}
          emptyText={plannerEmptyText}
        />
      ) : null}
    </>
  );
}
